import React from 'react';
import CategoryBanner from '../../components/Category/CategoryBanner/CategoryBanner';
import CategoryContainer from '../../components/Category/CategoryContainer/CategoryContainer';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import SubHeader from '../../components/Common/SubHeader/SubHeader';

const Category = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <CategoryBanner/>
            <CategoryContainer/>
            <Footer/>
        </div>
    );
};

export default Category;